import { Component, Input, OnInit } from '@angular/core';
import { ProgressInfo } from 'src/app/services/action-command.service';

@Component({
    selector: 'app-comand-progress-dialog-container',
    templateUrl: './comand-progress-dialog-container.component.html',
    styleUrls: ['./comand-progress-dialog-container.component.scss'],
    standalone: false
})
export class ComandProgressDialogContainerComponent implements OnInit {

  @Input('refreshRunning') isRefreshRunning: boolean = false;
  @Input() commandProgress: ProgressInfo;

  constructor() { }

  ngOnInit(): void {
  }

}
